import React, { useEffect, useMemo, useState } from "react"
import ReactSelect from "react-select"
import { twMerge } from "tailwind-merge"

import { selectStyling } from "../../utils/utils"

const ServiceSelector = ({ services, selectedServiceIds, onChange, className, disabled }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const serviceOptions = useMemo(
    () =>
      services.map((service) => ({
        value: service.id,
        label: service.name
      })),
    [services]
  )

  const selectedOptions = useMemo(
    () => serviceOptions.filter((option) => selectedServiceIds.some((id) => String(id) === String(option.value))),
    [serviceOptions, selectedServiceIds]
  )

  const wrapperClass = twMerge(className, disabled && "pointer-events-none opacity-50")

  if (!mounted) {
    const summary =
      selectedOptions.length > 0 ? selectedOptions.map((option) => option.label).join(", ") : "Select services..."

    return (
      <div className={wrapperClass}>
        <div className="rounded border border-gray-light bg-white px-3 py-2 text-sm text-gray-dark">{summary}</div>
      </div>
    )
  }

  return (
    <div className={wrapperClass}>
      <ReactSelect
        isMulti
        options={serviceOptions}
        value={selectedOptions}
        onChange={(selected) => !disabled && onChange(selected ? selected.map((s) => s.value) : [])}
        styles={selectStyling()}
        placeholder="Select services..."
        disabled={disabled}
      />
    </div>
  )
}

export default ServiceSelector
